import { AxiosInstance } from "axios";

export default class FilesServices {
  private axios: AxiosInstance;
  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  // GET A FILE
  public async GetFiles(id: string): Promise<void> {
    const url = `/files/${id}`;

    const blob = (await this.axios.get(url, { responseType: "blob" })) as Blob;

    if (!blob) return;

    const urlPdf = URL.createObjectURL(blob);

    const link = document.createElement("a");

    Object.assign(link, {
      href: urlPdf,
      target: "_blank",
    });

    link.click();
  }

  public async getCertificateAWSFileById(id: any) {
    const url = `${process.env.REACT_APP_API_LAVORIS_URL}v1/files/certificate/aws/${id}`;

    let downloadWindow = window.open(url, '_blank');

    if (downloadWindow) {
      downloadWindow.onload = function () {
        downloadWindow?.close();
      }
    }
  }

  public async getReportAWSFileById(id: any) {
    const url = `${process.env.REACT_APP_API_LAVORIS_URL}v1/files/report/aws/${id}`;

    let downloadWindow = window.open(url, '_blank');

    if (downloadWindow) {
      downloadWindow.onload = function () {
        downloadWindow?.close();
      }
    }
  }

  public async getAWSTurnFile(id: any) {
    const url = `${process.env.REACT_APP_API_LAVORIS_URL}v1/files/turnFiles/aws/${id}`;

    let downloadWindow = window.open(url, '_blank');

    if (downloadWindow) {
      downloadWindow.onload = function () {
        downloadWindow?.close();
      }
    }
  }





}
